import type { ReactNode } from "react";
import type { ViewStyle } from "react-native";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../../../useAppTheme";
import { useDevice } from "../../../../useDevice";
import Box from "../../../Box";

type Props = {
	title?: string;
	gap?: number;
	style?: ViewStyle;
	children: ReactNode;
};

export const PreTestCard = ({ title, gap, style, children }: Props) => {
	const theme = useAppTheme();
	const { isMobile } = useDevice();

	return (
		<Box
			backgroundColor={theme.colors.surface}
			padding={isMobile ? 16 : 24}
			gap={gap ?? (isMobile ? 16 : 24)}
			style={[{ borderRadius: theme.roundness * 3 }, style]}
		>
			{title ? <Text variant="headlineSmall">{title}</Text> : null}
			{children}
		</Box>
	);
};
